"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bus_query_operation_1 = require("@comunica/bus-query-operation");

var crypto_1 = require("crypto");

var rdf_string_1 = require("rdf-string");
/**
 * A comunica Hash Query Operation Actor.
 */


var AbstractFilterHash =
/*#__PURE__*/
function (_bus_query_operation_) {
  _inherits(AbstractFilterHash, _bus_query_operation_);

  function AbstractFilterHash(args, operator) {
    var _this;

    _classCallCheck(this, AbstractFilterHash);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AbstractFilterHash).call(this, args, operator));

    if (!AbstractFilterHash.doesHashAlgorithmExist(_this.hashAlgorithm)) {
      throw new Error("The given hash algorithm is not present in this version of Node: " + _this.hashAlgorithm);
    }

    if (!AbstractFilterHash.doesDigestAlgorithmExist(_this.digestAlgorithm)) {
      throw new Error("The given digest algorithm is not present in this version of Node: " + _this.digestAlgorithm);
    }

    return _this;
  }
  /**
   * Check if the given hash algorithm (such as sha1) exists.
   * @param {string} hashAlgorithm A hash algorithm.
   * @return {boolean} If it exists.
   */


  _createClass(AbstractFilterHash, [{
    key: "testOperation",
    value: function () {
      var _testOperation = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(pattern, context) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", true);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function testOperation(_x, _x2) {
        return _testOperation.apply(this, arguments);
      }

      return testOperation;
    }()
  }], [{
    key: "doesHashAlgorithmExist",
    value: function doesHashAlgorithmExist(hashAlgorithm) {
      return crypto_1.getHashes().indexOf(hashAlgorithm) >= 0;
    }
    /**
     * Check if the given digest (such as base64) algorithm exists.
     * @param {string} digestAlgorithm A digest algorithm.
     * @return {boolean} If it exists.
     */

  }, {
    key: "doesDigestAlgorithmExist",
    value: function doesDigestAlgorithmExist(digestAlgorithm) {
      return ["latin1", "hex", "base64"].indexOf(digestAlgorithm) >= 0;
    }
    /**
     * Create a string-based hash of the given object.
     * @param {string} hashAlgorithm A hash algorithm.
     * @param {string} digestAlgorithm A digest algorithm.
     * @param bindings The bindings to hash.
     * @return {string} The object's hash.
     */

  }, {
    key: "hash",
    value: function hash(hashAlgorithm, digestAlgorithm, bindings) {
      var hash = crypto_1.createHash(hashAlgorithm);
      hash.update(require('json-stable-stringify')(bindings.map(rdf_string_1.termToString)));
      return hash.digest(digestAlgorithm);
    }
  }]);

  return AbstractFilterHash;
}(bus_query_operation_1.ActorQueryOperationTypedMediated);

exports.AbstractFilterHash = AbstractFilterHash;